import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Container from "component/Layout/Container";
import ButtonHapticWrapper from "component/Button/ButtonHapticWrapper";
import "css/cards-v2.scss";

const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container id="home">
            <main className="flex-1 flex flex-col items-center justify-center px-4 text-center">
                <div className="relative">
                    <div
                        className="absolute inset-0 -z-10 pointer-events-none scale-[1.4]"
                        style={{
                            background: "radial-gradient(ellipse at center, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.08) 40%, transparent 75%)",
                            filter: "blur(24px)",
                        }}
                    />
                    <div style={{ transform: "rotate(-6deg)" }}>
                        <div className="card-container">
                            <div className="card-inner">
                                <div className="card r0">
                                    <div>?</div>
                                    <div>?</div>
                                    <div>?</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <p className="mt-6 font-changa-one text-white text-2xl lg:text-3xl uppercase tracking-wide">
                    {t("not_found.title")}
                </p>

                <p className="mt-3 text-white/60 text-sm lg:text-base max-w-sm">
                    {t("not_found.description")}
                </p>

                <ButtonHapticWrapper>
                    <button
                        onClick={() => navigate("/")}
                        className="mt-8 h-12 px-8 rounded-full bg-white/10 hover:bg-white/15 border border-white/15 text-white font-changa-one transition-colors cursor-pointer"
                    >
                        {t("not_found.back_home")}
                    </button>
                </ButtonHapticWrapper>
            </main>
        </Container>
    );
};

export default NotFound;
